<template>
  <div>
    <!--<lxm-nav></lxm-nav>-->

    <template v-if="isEmpty">
      <lxm-empty :text="'登录灵析电脑版，可以新建活动哦～'"></lxm-empty>
    </template>
    <template v-else>
      <template v-if="blocked">
        <lxm-empty :text="'如需在手机上查看数据，请登录电脑升级为付费版哦。'"></lxm-empty>
      </template>
      <template v-else>
        <div class="page">
        <div>
          <transition-group name="lxm-content-transition" tag="div" mode="out-in">
            <lxm-item v-for="item in items"
                      :key="item"
                      :name="item.name"
                      :value="item.value"
                      :update="item.update"
                      :valueSuffix="item.valueSuffix"
                      :to="item.to"></lxm-item>
          </transition-group>
        </div>
        <lxm-more v-if="hasMore" :loading="loading" @click="moreClicked"></lxm-more>
      </div>
      </template>
    </template>
    
    <!--<lxm-bottom-tabs><lxm-bottom-tabs>-->
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
</style>

<script>
  import LxmNav from '../common/LxmNav.vue'
  import LxmItem from '../common/LxmItem.vue'
  import LxmMore from '../common/LxmMore.vue'
  import LxmBottomTabs from '../common/LxmBottomTabs.vue'
  import LxmEmpty from '@/components/Main/Empty.vue'
  import LxmBlocked from '@/components/Main/Blocked.vue'
  import { getCfItems } from '../../../utils'
  import * as aTypes from '../../../store/action-types'
  import * as mTypes from '../../../store/mutation-types'
  export default {
    components: {
      LxmNav,
      LxmItem,
      LxmMore,
      LxmBottomTabs,
      LxmEmpty,
      LxmBlocked
    },
    computed: {
      currentPage () {
        return this.$store.state.cf.currentPage
      },
      hasMore () {
        return this.$store.state.cf.hasMore
      },
      loading () {
        return this.$store.state.loading[aTypes.CF_GET_LIST]
      },
      items () {
        const list = this.$store.state.cf.list
        return getCfItems(list)
      },
      isEmpty () {
        return this.$store.state.cf.list.length === 0
      },
      blocked () {
        return !this.$store.state.teamInfo.dataEnabled
      }
    },
    mounted () {
      this.$store.commit(mTypes.SET_NAV_TITLE, '')
      if (!this.$store.state.loaded.cf.list) {
        this.$store.dispatch(aTypes.CF_GET_LIST, {
          page: 1,
          append: false
        })
      }
      this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '到达筹款列表页' })
    },
    methods: {
      moreClicked () {
        this.$store.dispatch(aTypes.CF_GET_LIST, {
          page: this.currentPage + 1,
          append: true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?36a04eaf